module.exports = __webpack_public_path__ + "img/53_26.941c78c9.png";